import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Restores the scroll position to the top on forward navigation.
 *
 * Previously each page called `window.scrollTo(0, 0)` from an effect
 * keyed on its fetched data, which yanked the viewport back to the top
 * every time a request resolved — including for the product rails
 * embedded halfway down the landing page.
 *
 * POP navigations (browser back/forward) are left alone so the browser
 * can restore the previous position itself.
 */
const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP') return;

    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, search, navigationType]);

  return null;
};

export default ScrollToTop;
